import { render, staticRenderFns } from "./MyInsurance.vue?vue&type=template&id=f6d95c96&scoped=true&"
import script from "./MyInsurance.vue?vue&type=script&lang=js&"
export * from "./MyInsurance.vue?vue&type=script&lang=js&"
import style0 from "./MyInsurance.vue?vue&type=style&index=0&id=f6d95c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d95c96",
  null
  
)

export default component.exports